<template>
   <label :for="fieldData.name" 
      class="classLabel col-10 px-0 pt-1">{{ fieldData.label }}</label>
      <button 
            type="button"
            class="btn btn-sm col-2 px-0 pt-1 border-0" 
            :tabindex="tabindex + 1" 
            @click="$emit('onButtonClick')"
            >
            <slot></slot>
      </button>
   <Field :name="fieldData.name" 
      class="form-control col-12 py-0 px-1" 
      v-slot="{ field }"
      >
      <input v-bind="field" 
         class="form-control col-12 p-0 px-1"
         type="text" 
         :tabindex="tabindex"
         :id="id"
         :readonly="readonly"
         @blur="$emit('onBlur')"
         @focus="$emit('onFocus')"
         />
      <!-- 
      <button :id="resetButton" v-show="false" @click="field.value = newValue"></button>
      v-slot="{ field, resetField }"
      <button :id="resetButton" v-show="false" @click="resetField({ value: newValue })"></button>
         -->
   </Field>
   <div class="col-12 text-end fst-italic fs-14">
      <ErrorMessage
         :name="fieldData.name" 
         class="error-feedback" 
         />
   </div>
</template>

<script>
import { watchEffect } from 'vue';
import { Field, ErrorMessage, useField } from "vee-validate";

export default {
   name: 'CommonField01',
   components: {
      Field,
      ErrorMessage,
   },
   props: {
      fieldData: {
         type: Object,
         required: true,
      },
      id: { 
         type: String,
         default: 'text'
      },
      tabindex: { type: Number },
      /*
      resetButton: { 
         type: String,
         default: 'specialResetButton'
      },
      */
      newValue: { 
         type: String,
         default: ''
      },
      changeValue: {
         type: Boolean,
         default: false
      },
      readonly: {
         type: Boolean,
         default: false
      },
   },
   emits: [ 'onButtonClick', 'onBlur', 'onFocus' ],
   
   setup( props ) {
      const { meta, value } = useField( props.fieldData.name )
      watchEffect(() => {
         console.log(props.changeValue)
         if ( props.changeValue ) {
            console.log(props.newValue)
            value.value = props.newValue
         }
      })
      return { meta }
   }
   
}
</script>

<style>
.fs-14 {
   font-size: 14px;
}
</style>